import Link from 'next/link';

import Building from '@/icons/duotone/building.svg';
import { Button, Container } from '@/atoms';
import { FeaturedText } from '@/molecules';

import { isBotonContacto, useBotonContacto } from '@/hooks/useBotonContacto';
/**
 * ComponentRevisadasCtoWithBanner
 */
import { sectionBgProps, textStyleClass } from '@/utils';

export const ComponentRevisadasCtoWithBanner = ({
  Desciption,
  DescripcionEstilo,
  CtaBoton,
  FondoSeccion,
}: any) => {
  const { modal, abrirContacto } = useBotonContacto();
  const contacto = isBotonContacto(CtaBoton);

  return (
    <Container wrapper {...sectionBgProps(FondoSeccion)}>
      <FeaturedText
        Icon={Building}
        text={Desciption}
        textStyleClass={textStyleClass(DescripcionEstilo)}
      >
        {contacto ? (
          <Button
            type="button"
            size={CtaBoton.Size}
            variant={CtaBoton.Variante}
            className="shrink-0"
            onClick={() => abrirContacto(CtaBoton)}
          >
            {CtaBoton.Texto}
          </Button>
        ) : (
          <Link href={CtaBoton.Link} prefetch={false} passHref legacyBehavior>
            <Button
              as="a"
              size={CtaBoton.Size}
              variant={CtaBoton.Variante}
              className="shrink-0"
            >
              {CtaBoton.Texto}
            </Button>
          </Link>
        )}
      </FeaturedText>
      {contacto && modal}
    </Container>
  );
};

ComponentRevisadasCtoWithBanner.displayName = 'ComponentRevisadasCtoWithBanner';
